import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useLocalStorage } from 'common/hooks';

type Props = {
  rootRoute: string;
  defaultSubRoute: string;
  localStorageKey: string;
  children?: React.ReactNode;
};

const RootRedirector = ({ rootRoute, defaultSubRoute, localStorageKey, children }: Props) => {
  const [persistedSubroute, setPersistedSubroute] = useLocalStorage(localStorageKey, defaultSubRoute);
  const location = useLocation();
  const subRoute = `${location.pathname}${location.search}`.substring(rootRoute.length);
  useEffect(() => {
    if (subRoute === '') {
      return;
    }
    setPersistedSubroute(subRoute);
  }, [setPersistedSubroute, subRoute]);
  return <>{subRoute === '' ? <Redirect to={`${rootRoute}${persistedSubroute}`} /> : children}</>;
};

export default RootRedirector;
